export default "__VITE_ASSET__XMHN4Ryz__"